/* eslint-disable @typescript-eslint/no-explicit-any */
import dateFormat from 'dateformat'

import { DueOut } from '../data/dueout/dueout'
import { Inquiry } from '../data/inquiry/inquiry'
import { STATUS_CODE } from '../data/inquiry/inquiry-status-metadata'
import { CsvTitles } from './data-and-time.types'

const currentUTCDate = new Date().toISOString()

function getCurrentUTCDate() {
  return new Date().toISOString()
}

function formatUTCDateToLocal(dateToFormat) {
  const date = new Date(Date.parse(dateToFormat))
  let formattedDate = date.toLocaleString([], {
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
  formattedDate = formattedDate?.split(',')?.join(' ')

  return formattedDate
}

function formatDatetoTime(dateToFormat) {
  const date = new Date(Date.parse(dateToFormat))
  let hoursMin = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  hoursMin = hoursMin?.split(',')?.join(' ')
  return hoursMin
}

function localDateToUTCDate(dateString) {
  const date = new Date(dateString)
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  ).toISOString()
}

function getFiscalYear(dateString) {
  if (dateString) {
    const date = new Date(dateString)
    const currentMonth = date.getUTCMonth() + 1
    const fiscalyear =
      currentMonth >= 10 ? date.getUTCFullYear() + 1 : date.getUTCFullYear()
    return fiscalyear
  }
}

function validateDate(date) {
  if (date !== undefined && date !== '') {
    const datearr = date.split('-')
    if (datearr == null) {
      return false
    }
    const month = datearr[1]
    const day = datearr[2]
    const year = datearr[0]
    if (
      year === undefined ||
      month === undefined ||
      day === undefined ||
      year === 'undefined' ||
      month === 'undefined' ||
      day === 'undefined'
    ) {
      return false
    }
    if (
      month < 1 ||
      month > 12 ||
      day < 1 ||
      day > 31 ||
      isNaN(day) ||
      year.length > 4 ||
      year === '' ||
      year === 'undefined' ||
      year === undefined ||
      parseInt(year) < 1900 ||
      parseInt(year) > 2099
    ) {
      return false
    } else if (month === 2) {
      const isleap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)
      if (day > 29 || (day === 29 && !isleap) || isNaN(day)) {
        return false
      }
    } else if (month === 4 || month === 6 || month === 9 || month === 11) {
      if (day > 30 || isNaN(day)) {
        return false
      }
    }
  } else {
    return false
  }
  return true
}

const convertDateToLocaleDate = (date: Date): string => {
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }
  const formattedDate = date.toLocaleString('en-US', options)
  return formattedDate
}
//Number of days to resolve//
const getDaysBetween = (dateCreated, dateResolved) => {
  dateCreated = convertDate(dateCreated, 'date')
  dateResolved = convertDate(dateResolved, 'date')
  if (
    dateCreated == null ||
    dateCreated === '' ||
    dateResolved == null ||
    dateResolved === ''
  ) {
    return this
  } else {
    const mdyCreated = dateCreated.split('/')
    const mdyResolved = dateResolved.split('/')
    dateCreated = new Date(mdyCreated[2], mdyCreated[0] - 1, mdyCreated[1])
    dateResolved = new Date(mdyResolved[2], mdyResolved[0] - 1, mdyResolved[1])

    return Math.round((dateResolved - dateCreated) / (1000 * 60 * 60 * 24))
  }
}
/** convertDate:
 * takes 2 args serverDate and formatter,
serverDate is the date we want converted and formatter is a string
with how to covert the date.
formatter options = 'date', 'newdate', 'Month', 'Day', 'Time', 'shortTime'
*/
function convertDate(serverDate, formatter) {
  let createdDate = ''
  if (serverDate !== '' && serverDate != null && serverDate !== undefined) {
    const dt = new Date(serverDate)
    // Format: mm/dd/yyyy Example: 06/09/2007
    createdDate = dateFormat(dt, 'paddedShortDate')
    if (formatter === 'date') {
      // 02/11/22 02:22 AM
      createdDate = dateFormat(dt, 'mm/dd/yyyy hh:MM TT')
    } else if (formatter === 'Year') {
      /*    Year represented by four digits. */
      createdDate = dateFormat(dt, 'yyyy')
    } else if (formatter === 'newdate') {
      /* Month as a 3-letter abbreviation,
      Day of the month as digits leading zero for single-digit days,
      Year represented by 4 digits. */
      createdDate = dateFormat(dt, 'mmm dd, yyyy')
    } else if (formatter === 'Month') {
      // Month as a 3-letter abbreviation.
      createdDate = dateFormat(dt, 'mmm')
    } else if (formatter === 'Day') {
      // Day of the month as digits no leading zero for single-digit days.
      createdDate = dateFormat(dt, 'd')
    } else if (formatter === 'Time') {
      // Format: h:MM TT Example: 5:46 PM
      createdDate = dateFormat(dt, 'shortTime')
    } else if (formatter === 'dateInput') {
      // 2023-11-02
      createdDate = dateFormat(dt, 'yyyy-mm-dd')
    } else if (formatter === 'historyInput') {
      createdDate = dateFormat(dt, 'mm/dd/yyyy - hh:MM TT')
    } else if (formatter === 'notification') {
      createdDate = dateFormat(dt, 'mm/dd/yyyy | hh:MM TT')
    }
  }
  return createdDate
}

function getTotalNumberOfDaysforInquiry(item: Inquiry): string {
  const millisecondsPerDay = 1_000 * 3_600 * 24

  if (!item.ItemCreated) return '0'

  const deltaDays = (d1: Date | null | string | undefined) => {
    if (!d1 || d1 === '' || !item.ItemCreated) return 0
    const d2 = new Date(item.ItemCreated)
    d1 = typeof d1 === 'string' ? new Date(d1) : d1

    const differenceInTime = d1.getTime() - d2.getTime()

    if (d1.getDate() === d2.getDate()) {
      return Math.floor(differenceInTime / millisecondsPerDay)
    } else {
      return Math.ceil(differenceInTime / millisecondsPerDay)
    }
  }

  let days = 0
  if (item.StatusCode === STATUS_CODE.CANCELED) {
    days = deltaDays(item.ItemModified)
  } else if (
    item.StatusCode === STATUS_CODE.RESOLVED ||
    item.StatusCode === STATUS_CODE.CLOSED
  ) {
    days = deltaDays(item.ResolvedDate)
  } else {
    days = deltaDays(new Date())
  }

  return days.toLocaleString()
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getTotalNumberOfDaysforDueOut(item: DueOut): string {
  return '0'
}

/**
 *
 * @param {*} csvTitle - the current page the user is on
 * @param {*} isDueOutTab - boolean that represents if the user is on a due out tab or page
 * @param {*} workItem - the current Inquiry or Due Out object
 * @param {*} type
 * @returns a number that represents the number of days between two dates
 */

const getTotalNumberOfDays = (
  csvTitle: CsvTitles,
  isDueOutTab: boolean,
  workItem,
  type: 'ARCHIVED DUEOUTS' | 'ARCHIVED INQUIRIES' | 'CUSTOMER' | null = null,
  statusCodesMetadata: any
) => {
  const StatusCodes: string[] = Object?.values(statusCodesMetadata)?.map(
    ({ StatusCode }: any) => {
      return StatusCode
    }
  )
  if (!workItem) return

  const {
    CanceledDate,
    ClosedDate,
    CustomerActionRequired,
    ItemCreated,
    ItemModified,
    ReopenedDate,
    ResolvedDate,
    StatusCode,
  } = workItem

  let TotalNumberOfDaysCount = 0
  const isInquiryTab =
    csvTitle === 'ALL INQUIRIES' || csvTitle === 'MY INQUIRIES'
  const isInProgress = !isDueOutTab && !CustomerActionRequired
  const isCompleted = csvTitle === 'COMPLETED INQUIRIES'

  const calculateDays = (startDate, endDate) => {
    return numberOfDaysTillDate(startDate, endDate)
  }
  const handleReopenOrSubmitted = (statusId: string, statusCodes) => {
    const activatedDate =
      statusId === statusCodes.StatusCode ? ItemCreated : ReopenedDate
    return calculateDays(activatedDate, null)
  }

  const isResolvedCanceledClosed = (status) => {
    return (
      status ===
        StatusCodes.find((status) => status === STATUS_CODE.RESOLVED) ||
      status ===
        StatusCodes.find((status) => status === STATUS_CODE.CANCELED) ||
      status === StatusCodes.find((status) => status === STATUS_CODE.CLOSED)
    )
  }
  const isReopenOrSubmitted = (status) => {
    return (
      status ===
        StatusCodes.filter((status) => status === STATUS_CODE.SUBMITTED) ||
      status === StatusCodes.filter((status) => status === STATUS_CODE.REOPENED)
    )
  }
  // Inquiry section
  if (isInquiryTab || isCompleted) {
    if (isInProgress && !isCompleted) {
      if (isReopenOrSubmitted(StatusCode)) {
        TotalNumberOfDaysCount =
          handleReopenOrSubmitted(StatusCode, StatusCodes) ?? 0
      }
    }
    if (isResolvedCanceledClosed(StatusCode)) {
      if (
        StatusCode ===
        StatusCodes.find((status) => status === STATUS_CODE.RESOLVED)
      ) {
        TotalNumberOfDaysCount = calculateDays(ItemCreated, ResolvedDate) ?? 0
      }
      if (
        StatusCode ===
        StatusCodes.find((status) => status === STATUS_CODE.CANCELED)
      ) {
        TotalNumberOfDaysCount = calculateDays(ItemCreated, CanceledDate) ?? 0
      }
    } else if (ItemModified) {
      TotalNumberOfDaysCount = calculateDays(ItemModified, null) ?? 0
    } else if (!isDueOutTab && type === 'CUSTOMER') {
      if (!CustomerActionRequired && ItemModified) {
        TotalNumberOfDaysCount = calculateDays(ItemModified, null) ?? 0
      }
    }

    // Dueout section
    if (isDueOutTab || isCompleted) {
      if (
        StatusCode === StatusCodes.find((status) => status === 'NOT_STARTED')
      ) {
        TotalNumberOfDaysCount = calculateDays(ItemCreated, null) ?? 0
      } else if (
        StatusCode === StatusCodes.find((status) => status === 'IN_PROGRESS')
      ) {
        TotalNumberOfDaysCount = calculateDays(ItemModified, null) ?? 0
      } else if (isResolvedCanceledClosed(StatusCode)) {
        const completedDueOutDate =
          StatusCode === StatusCodes.find((status) => status === 'RESOLVED')
            ? ItemModified
            : StatusCode === StatusCodes.find((status) => status === 'CANCELED')
            ? CanceledDate
            : ClosedDate
        TotalNumberOfDaysCount =
          calculateDays(ItemCreated, completedDueOutDate) ?? 0
      }
    }
  }

  return TotalNumberOfDaysCount
}
// dt1 and dt2 are utc date strings in the format of "2023-08-11T20:41:08Z"
// numberOfDaysTillDate<number> returns the number of days between the two dates i.e 9
const numberOfDaysTillDate = (dt1, dt2 = null) => {
  const startDate = new Date(dt1)
  const endDate = dt2 === null ? new Date() : new Date(dt2)
  if (startDate instanceof Date && endDate instanceof Date) {
    const differenceInTime = endDate.getTime() - startDate.getTime()
    if (differenceInTime)
      return Math.round(differenceInTime / (1000 * 3600 * 24))
  }
}

export {
  convertDate,
  convertDateToLocaleDate,
  currentUTCDate,
  formatDatetoTime,
  formatUTCDateToLocal,
  getCurrentUTCDate,
  getDaysBetween,
  getFiscalYear,
  getTotalNumberOfDays,
  getTotalNumberOfDaysforDueOut,
  getTotalNumberOfDaysforInquiry,
  localDateToUTCDate,
  numberOfDaysTillDate,
  validateDate,
}
